import React, { useState, useContext, useEffect, Suspense } from 'react';
import { TransitionContext } from '../Context/TransitionContext';

import './Terms.css';

import { useScreenTransition } from '../Hooks/useScreenTransition';
import SignInForm from './SignIn/SignInForm';
import CreateAccount from './CreateAccount/CreateAccount';


import Navbar from './HomePage/header';

import Footer from './HomePage/footer';
import SupportSection from './HomePage/SupportSection';
import axios from 'axios';
import { Lock } from 'react-feather';

import { FormTextInput } from '../Components/FormTextInput';
import { NotificationContext } from '../Context/NotificationContext';
import { useEnterKey } from '../Hooks/useEnterKey';
import { getFullHttpUrl } from '../firebase.config';
import { EAST1, EAST4 } from '../utility/enums';
import NewButton from '../NewComponents/NewButton';

import { Check, X } from 'react-feather';

import { AltAnimatedButton } from '../Components/AltAnimatedButton';
import TopBar from '../Components/TopBar';

import { Mail } from 'react-feather';

import { FormTextArea } from '../Components/FormTextArea';
import { AuthContext } from '../Context/AuthContext';

import './Contact.css';
import CustomerReviews from './HomePage/CustomerReviews';

const Contact = ({ windowSize }) => {

  const { setColor } = useContext(TransitionContext);

  // const { showNotification } = useContext(NotificationContext);

  // const { signedIn } = useContext(AuthContext);

  // const { transitionTo } = useScreenTransition();

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  // const [name, setName] = useState('');
  // const [email, setEmail] = useState('');
  // const [message, setMessage] = useState('');

  // const [submitButton, setSubmitButton] = useState('Submit');

  const [isModalOpen, setIsModalOpen]=useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen]=useState(false);


  const handleLoginOpen=(newState)=>{
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen=(newState)=>{
    setIsCreateAccountOpen(newState);
  }

  // const handleSubmit = () => {
  //   setSubmitButton('Submitting...');

  //   axios({
  //     method:'post',
  //     url: getFullHttpUrl("contactFormSubmitted", EAST4),
  //     data: {
  //       name: name,
  //       email: email.toLowerCase(),
  //       message: message
  //     }
  //   })
  //     .then((response) => {
  //       setName('');
  //       setEmail('');
  //       setMessage('');
  //       setSubmitButton('Submit');
  //       showNotification("Success", "Your message was successfully sent to our Support team.", "success");
  //     })
  //     .catch((error) => {
  //       setSubmitButton('Submit');
  //       showNotification("Error", "An error ocurred sending your message. Please, try again. If it persists, contact technical support at support@everbary.com", "error");
  //     });
  // }

  return (
    <div className='bg-[#EFF3F5] w-full flex flex-col items-center cursor-default'>
    <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen}/>
    <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen}/>


     {/* banner */}
     <div className='w-full md:p-4 p-2'>

      <div className='w-full bg-[#12ABBF] rounded-4xl max-md:rounded-xl max-md:pb-4'>
          {/* navbar */}
        <div className=' pt-[30px] pb-[27px] mx-4'>
            <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen}/>
        </div>
        
      </div>
      

      <SupportSection windowSize={windowSize} />

      <Suspense fallback={<div></div>}>
        <CustomerReviews mTop="mt-5" />
      </Suspense>

     </div>

    <div className=' w-full pb-10 bg-[#12ABBF]'>
          <Footer windowSize={windowSize} light={true}  />
      </div>  

  </div>
  
  );
}

export default Contact;